import QueryBuilder from "../QueryBuilder"

export default class IconTableRepository {
    constructor(public contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, [
                "bannerText",
                "text_highlight",
                "banner_label",
                "subheaderText",
                "cta_enabled",
                "cta_text",
                "cta_redirection",
                "iconList",
            ])
            .process()

        return results.getResultInfo()
    }
}
